// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Js4y","newExpiryDate":"styles_newExpiryDate__1F7-t","footer":"styles_footer__1sXK0"};